import { applyAssetResolution, buildAssetUrl } from "../../pixi/assetsInit";

export const generateAssetLink = (path: string) => {
  return buildAssetUrl(applyAssetResolution(`/asset_baseOptimized/${path}`));
};
